var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 8.5L7.5625 11.3125L12.25 5.6875M1 13.0002V4.00019C1 2.95008 1 2.42464 1.20437 2.02356C1.38412 1.67075 1.67075 1.38412 2.02356 1.20437C2.42464 1 2.95008 1 4.00019 1H13.0002C14.0503 1 14.5746 1 14.9757 1.20437C15.3285 1.38412 15.6161 1.67075 15.7958 2.02356C16 2.42425 16 2.94905 16 3.9971V13.0034C16 14.0514 16 14.5755 15.7958 14.9762C15.6161 15.3289 15.3285 15.6161 14.9757 15.7958C14.575 16 14.0509 16 13.0029 16H3.9971C2.94905 16 2.42425 16 2.02356 15.7958C1.67075 15.6161 1.38412 15.3289 1.20437 14.9762C1 14.5751 1 14.0503 1 13.0002Z",
    stroke: "#4F8CE7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueBox);
export default __webpack_public_path__ + "static/media/blueBox.659c5707d1e2cbca9ea4b0392758d64e.svg";
export { ForwardRef as ReactComponent };